export const useNormalizeWishText = () => {

  const normalizeWish = (wishText: string) => {
      if(wishText === null || wishText === undefined || wishText === '') {
        return ''
      }

      return wishText
      .replace(/[\u00A0\u2000-\u200B\u202F\u205F\u3000\u3164]/g, ' ')
      .replace(/ {2,}/g, ' ')
      .trim()
    }

    return  {
      normalizeWish
    }

}